<template>
    <div v-bind:id="youTubeId" class="youtubevideo-container">
        <div v-bind:id="playerId" class="YouTubeVideo"></div>
    </div>
</template>

<script>
    export default {
        name: 'youtubevideo',
        props: {
            slideId: String,
            videoId: String,
        },
        computed: {
            playerId: function() {
                return `player${this.slideId}`;
            },
            youtubeId: function() {
                return `youtubeplayer{this.slideId}`;
            },
        },
        methods: {},
        // Life Cycle
        created: function() { },
        mounted: function() {
            new YT.Player(this.playerId,{
                height: '100%',
                width: '100%',
                videoId: this.$props.videoId,
            })
        },
    };
</script>

<style lang="scss">
    .youtubevideo-container {
        height: 100%;
        background: black;
    }
</style>
